export default "__VITE_ASSET__DGwVnakX__"